import { render, staticRenderFns } from "./DeletedRowsPanel.vue?vue&type=template&id=3575d027&scoped=true&"
import script from "./DeletedRowsPanel.vue?vue&type=script&lang=js&"
export * from "./DeletedRowsPanel.vue?vue&type=script&lang=js&"
import style0 from "./DeletedRowsPanel.vue?vue&type=style&index=0&id=3575d027&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3575d027",
  null
  
)

export default component.exports